import { IGroup } from '../../interface/Group'

export const defaultGroupOption: Readonly<Required<IGroup>> = {
  opacity: 0.1,
  backgroundColor: '#E99D00',
  activeOpacity: 0.5,
  activeBackgroundColor: '#E99D00',
  disabled: false
}
